import React from 'react';
import { Col, Row } from 'reactstrap';

const style = { display: 'inline-flex' };

const BasicRowColGrid = ({ children, fieldNameCol, fieldCol }) => {
  let validator,
    isRequired = false;
  for (const { props } of children) {
    if (!props) {
      continue;
    }
    validator = props.validate;
    if (validator) {
      if (!Array.isArray(validator)) {
        validator = [validator];
      }
      const index = validator.findIndex(
        validateFn => validateFn.name === 'required'
      );
      isRequired = index !== -1 ? true : false;
    }
  }
  return (
    <Row style={{ width: '100%' }} className="mb-2">
      <Col {...fieldNameCol}>
        {children[0]}
        {isRequired ? (
          <span style={{ color: 'red', fontSize: 12, fontWeight: 700 }}>
            {' '}
            *
          </span>
        ) : (
          ''
        )}
      </Col>
      <Col {...fieldCol}>
        {children[1]}
        {children[2] ? children[2] : null}
      </Col>
    </Row>
  );
};

const defaultProps = {
  fieldNameCol: {
    sm: 5,
    md: 5,
    lg: 3,
    xl: 3,
    style
  },
  fieldCol: {
    sm: 7,
    md: 7,
    lg: 9,
    xl: 9,
    style
  }
};

BasicRowColGrid.defaultProps = defaultProps;

export default BasicRowColGrid;

export { defaultProps };
